import React from 'react';
import { Checkbox, Menu, Dropdown } from '@platform/base';
import { getSysFieldid } from '@platform/api';
import { getCustomerColumnWidth } from '../../adapter/utils';
import classNames from 'classnames';

const MENU_ALL = "all";
const MENU_REVERSE = "reserve";
const MENU_PAGE = "page";
const COL_KEY_CHECKBOX = "CHECKBOX";

export default function useCheckbox(Table) {
    return class CheckboxTable extends React.Component{

        state = { 
            checkBoxMenuShow: false,
            headCheckboxChecked: false,
        }

        render(){
            let { checkboxConfig = {}, columns = [], rows, locale } = this.props,
                { enable = false, checkedKeys = new Set(), onCheck, more, width = 45, disabledKeys = new Set() } = checkboxConfig,
                { checkBoxMenuShow } = this.state;
            
            if(enable && columns.length){
                let menuItems = (
                        <Menu onClick={this.handleCheckMenuClick}>
                            <Menu.Item key={MENU_ALL}>{locale['table0036'] /*全选*/}</Menu.Item>
                            <Menu.Item key={MENU_REVERSE}>{locale['table0039'] /*全反选*/}</Menu.Item>
                            <Menu.Item key={MENU_PAGE}>{locale['table0040'] /*仅当前页*/}</Menu.Item>
                        </Menu>
                    ),
                    checked = checkedKeys.size > 0 && rows.every(row => disabledKeys.has(row.key) || checkedKeys.has(row.key)),
                    indeterminate = !checked && checkedKeys.size > 0 && rows.some(row => disabledKeys.has(row.key) || checkedKeys.has(row.key));

                columns = [{
                    title: 
                        <div 
                            className='table-next-header-checkbox' 
                            fieldid={getSysFieldid('firstcol')}
                        >
                            <Checkbox 
                                className='table-next-checkbox'
                                tabIndex="-1"
                                disabled={rows.length && rows.every(row => disabledKeys.has(row.key))}
                                checked={checked} 
                                indeterminate={indeterminate}
                                onChange={this.checkCurrentPage} 
                            />
                            {more && <Dropdown overlay={menuItems} trigger={['click']} onVisibleChange={this.handleDropdownVisible}>
                                <i 
                                    className={checkBoxMenuShow ? "iconfont icon-shangjiantou" : "iconfont icon-xiajiantou"}
                                />
                            </Dropdown>}
                        </div>,
                    key: COL_KEY_CHECKBOX,
                    width: width,
                    isLeaf: true,
                    depth: 0,
                    fixed: 'left',
                    render: row => {
                        return <div 
                            className='table-cell check-col'
                            fieldid={getSysFieldid('firstcol')}
                            // CheckBox 单元格点击事件与CheckBox选中事件保持一致
                            onClick={e => {
                                let checkedKey = row.key,
                                    checked = checkedKeys.has(checkedKey);

                                // 阻止冒泡防止行点击触发
                                e.stopPropagation();

                                if(disabledKeys.has(checkedKey)) return;

                                if (checked) {
                                    checkedKeys.delete(checkedKey);
                                } else {
                                    checkedKeys.add(checkedKey);
                                }

                                onCheck(checkedKey, { isChecked: !checked, checkedKeys });
                            }
                            }
                        >
                            <Checkbox 
                                className='table-next-checkbox'
                                disabled={disabledKeys.has(row.key)}
                                checked={checkedKeys.has(row.key)} 
                                onChange={value => {
                                    let checkedKey = row.key;
                                    if (value) {
                                        checkedKeys.add(checkedKey);
                                    } else {
                                        checkedKeys.delete(checkedKey);
                                    }
                                    onCheck?.(checkedKey, { isChecked: value, checkedKeys });
                                }} 
                                tabIndex="-1"
                                onClick={e => e.stopPropagation()} // TODO:确认一下和rowClick是否冲突
                            />
                        </div>;
                    },
                },
                ...columns,
                ];
            }
            
            return (
                <Table {...this.props} columns={columns}/>
            );
        }
        
        handleCheckMenuClick = ({ key }) => {
            let { checkboxConfig, allRowsInfo, rows, pkname } = this.props,
                { allpks } = allRowsInfo,
                { onCheck, checkedKeys = new Set(), allCheckedKeys = new Set() } = checkboxConfig,
                isCheckedAll = false;

            if(!allpks?.length) {
                console.warn('没有配置allpks');
                return;
            }

            switch(key){
                case MENU_ALL:
                    checkedKeys = new Set(rows.map(e => e.key));
                    allCheckedKeys = new Set(allpks);
                    isCheckedAll = true;
                    break;
                case MENU_REVERSE:
                    checkedKeys = new Set(rows.filter(e => !checkedKeys.has(e.key)).map(e => e.key));
                    allCheckedKeys = new Set(allpks.filter(pk => !allCheckedKeys.has(pk)));
                    break;
                case MENU_PAGE:
                    checkedKeys = new Set(rows.map(e => e.key));
                    allCheckedKeys = new Set(rows.map(row => {
                        let values = row.values || row;
                        return values[pkname].value;
                    }));
                    break;
                default:
                    break;
            }

            onCheck?.('', { isChecked: true, checkedKeys, allCheckedKeys, isCheckedAll });
            this.setState({ checkBoxMenuShow: false });
        }

        handleDropdownVisible = value => {
            this.setState({ checkBoxMenuShow: value });
        }

        checkCurrentPage = value => { 
            let { rows, checkboxConfig, pkname, crossPageSelect } = this.props,
                { onCheck, allCheckedKeys = new Set() } = checkboxConfig,
                checkedKeys;

            if (value) {
                // 全选
                checkedKeys = new Set(rows.map(e => e.key));
                pkname && crossPageSelect && rows.forEach(row => {
                    let values = row.values || row;
                    allCheckedKeys.add(values[pkname].value);
                });
            } else {
                // 全消
                checkedKeys = new Set();
                pkname && crossPageSelect && rows.forEach(row => {
                    let values = row.values || row;
                    allCheckedKeys.delete(values[pkname].value);
                });
            }
            onCheck?.('', { 
                isChecked: value,
                checkedKeys,
                allCheckedKeys: pkname && allCheckedKeys,
            });
        }
    };
}

const DEFAULT_INFO = { checkedKeys: new Set(), disabledKeys: new Set(), allCheckedKeys: new Set() };

// TODO:获取checkedKeys时拷贝，防止修改引用，拿不到旧的checkedKeys
useCheckbox.displayName = 'useCheckbox';
useCheckbox.dependence = [];
useCheckbox.hooks = function() {
    this.store.checkedInfo = {};
    return {
        getDisabledKeys: () => {
            return new Set(this.store.checkedInfo?.disabledKeys || new Set());
        },
        setDisabledKeys: (keys, { shouldUpdate = true } = {}) => {
            this.store.checkedInfo.disabledKeys = new Set(keys);
            shouldUpdate && this.forceUpdate();
        },
        getCheckedKeys: () => {
            return new Set(this.store.checkedInfo?.checkedKeys || new Set());
        },
        // isCheckedAll是个状态，兼容之前的设计
        setCheckedKeys: (keys, { shouldUpdate = true, isCheckedAll, skipDisabled = false } = {} ) => {
            let { disabledKeys = new Set(), checkedKeys = new Set(), allCheckedKeys = new Set() } = this.store.checkedInfo || {},
                { crossPageSelect, pkname } = this.store.componentConfig;

            !keys && (keys = new Set());
            keys = new Set([...keys].filter(key => !disabledKeys.has(key)));

            if (skipDisabled) {
                // 用户点击时跳过disabled
                // 禁用并且选中状态的保持
                [...disabledKeys].forEach(key => { 
                    if (checkedKeys.has(key)) {
                        keys.add(key);
                    }
                });
            } else {
                // api调用时操作disabled
                // 禁用的能删，不能增
                disabledKeys.forEach(key => {
                    keys.delete(key);
                });
            }

            // 更新allCheckedKeys（跨页选）
            if (crossPageSelect && pkname) {
                keys.forEach(key => {
                    if (!checkedKeys.has(key)) {
                        let row = this.getRowData(key),
                            values = row.values || row;

                        allCheckedKeys.add(values[pkname].value);
                    }
                });

                checkedKeys.forEach(key => {
                    if (!keys.has(key)) {
                        let row = this.getRowData(key);

                        if (!row) return;

                        let values = row.values || row;

                        allCheckedKeys.delete(values[pkname].value);
                    }
                });

                this.store.checkedInfo.allCheckedKeys = allCheckedKeys;
            }

            this.store.checkedInfo.checkedKeys = keys;
            this.store.checkedInfo.isCheckedAll = isCheckedAll;

            // 合计行有一个allowTotalRows属性，一般和checkbox配合
            // 暂时先这么写，有其他场景再补充
            this._updateTotal();
            shouldUpdate && this.forceUpdate();
        },
        getAllCheckedKeys: () => {
            return new Set(this.store.checkedInfo.allCheckedKeys || new Set());
        },
        // isCheckedAll是个状态，兼容之前的设计
        setAllCheckedKeys: (keys, { isCheckedAll, shouldUpdate = true } = {}) => {
            let { disabledKeys = new Set() } = this.store.checkedInfo || {},
                { crossPageSelect, pkname } = this.store.componentConfig;
            if (crossPageSelect && pkname) {
                let disabledPks = new Set([...disabledKeys].filter(key => !!this.getRowData(key)).map(key => {
                    let row = this.getRowData(key),
                        values = row.values || row;
                    return values[pkname]?.value;
                }));
                this.store.checkedInfo.allCheckedKeys = new Set([...keys].filter(pk => !disabledPks.has(pk)));
                this.store.checkedInfo.isCheckedAll = isCheckedAll;
            }
            shouldUpdate && this.forceUpdate();
        },
        getCheckedInfo: () => {
            let mergedInfo = { ...DEFAULT_INFO, ...this.store.checkedInfo };

            mergedInfo.checkedKeys = new Set(mergedInfo.checkedKeys);
            mergedInfo.allCheckedKeys = new Set(mergedInfo.allCheckedKeys);

            return mergedInfo;
        },
        setCheckedInfo: info => {
            return this.store.checkedInfo = info || { ...DEFAULT_INFO };
        },
        checkAll: () => {
            let rows = this.getVisibleRows(),
                { allpks } = this.getAllRowsInfo();

            rows && this.setCheckedKeys(new Set(rows.map(row => row.key)));
            allpks && this.setAllCheckedKeys(new Set(allpks));
        },
        checkReverse: () => {
            let { checkedKeys = new Set(), allCheckedKeys = new Set() } = this.store.checkedInfo || {};

            let rowKeys = this.getVisibleRowKeys(),
                { allpks } = this.getAllRowsInfo();

            this.setCheckedKeys(new Set(rowKeys.filter(key => !checkedKeys.has(key))));
            this.setAllCheckedKeys(new Set(allpks.filter(pk => !allCheckedKeys.has(pk))));
        },
        checkCurrentPage: () => {
            let rowKeys = this.getVisibleRowKeys();

            this.setCheckedKeys(rowKeys);
        },
        // isCheckedAll是个状态，兼容之前的设计
        isAllChecked: () => {
            return this.store.checkedInfo.isCheckedAll;
        },
        isCurrentPageAllChecked: () => {
            let { checkedKeys = new Set() } = this.store.checkedInfo || {},
                rows = this.getVisibleRows();

            if(!checkedKeys.size || !rows?.length || checkedKeys.size !== rows.length) return false;

            return rows.every(row => checkedKeys.has(row.key));
        },
        setLastCheckedKey: rowKey => {
            let info = { ...DEFAULT_INFO, ...this.store.checkedInfo };
            this.store.checkedInfo = { ...info, lastCheckedKey: rowKey };
        },
        getLastCheckedKey: () => {
            return this.store.checkedInfo?.lastCheckedKey;
        },
    };
};
useCheckbox.propsGenerator = function(props){
    // enable为false时只是不显示复选框，但勾选事件还是要触发
    // if(!checkboxConfig?.enable){
    //     return props;
    // }

    const { checkboxConfig, store, id, rowProps } = props,
        checkedInfo = store.getCheckedInfo(),
        { crossPageSelect, pkname } = store.getConfig() || {};

    const onCheck = (rowKey, { isChecked, checkedKeys, allCheckedKeys, isCheckedAll }) => {
        let lastCheckedKeys = store.getCheckedKeys();
        
        store.setCheckedKeys(checkedKeys, { isCheckedAll, skipDisabled: true });

        if (crossPageSelect && pkname) {
            if (allCheckedKeys) {
                store.setAllCheckedKeys(allCheckedKeys, { isCheckedAll, skipDisabled: true });
            }
        }

        if(rowKey && isChecked){
            store.setLastCheckedKey(rowKey);
        }

        checkboxConfig?.onCheck?.(rowKey, { isChecked, checkedKeys, lastCheckedKeys });
    };

    return {
        ...props,
        checkboxConfig: {
            ...checkboxConfig,
            ...checkedInfo,
            width: getCustomerColumnWidth(store, id, COL_KEY_CHECKBOX, 45),
            onCheck,
        },
        rowProps: (row, rowIndex) => {
            let rawRowProps = rowProps?.(row, rowIndex) ?? {},
                { disableClickRowToSelect } = rawRowProps,
                status = store.getStatus(),
                { crossPageSelect, pkname } = store.getConfig() || {};

            return disableClickRowToSelect ? rawRowProps : {
                ...rawRowProps,
                onClick: event => {
                    if(status === 'browse'){
                        let rowKey = row.key,
                            checkedKeys = store.getCheckedKeys(),
                            disabledKeys = store.getDisabledKeys(),
                            isClickCheck = checkedKeys.size === 1 && checkedKeys.has(rowKey);

                        if (!disabledKeys.has(rowKey)) {

                            let allCheckedKeys = null, checkedKeys = isClickCheck ? [] : [rowKey];
                            if (crossPageSelect && pkname) {
                                allCheckedKeys = checkedKeys.map(key => store.getRowData(key)?.values?.[pkname]?.value ?? '');
                            }
                            
                            onCheck(rowKey, { 
                                isChecked: !isClickCheck, 
                                checkedKeys: new Set(checkedKeys),
                                allCheckedKeys: allCheckedKeys && new Set(allCheckedKeys),
                            });
                        }
                    }
                    rawRowProps?.onClick?.(event);
                },
                className: classNames(rawRowProps.className, { 
                    'checked-row': checkedInfo.checkedKeys.has(row.key),
                    'select-disabled': checkedInfo.disabledKeys.has(row.key),
                }),
            };
        },
        cellProps: (rowInfo, colInfo) => {
            let rawCellProps = props.cellProps?.(rowInfo, colInfo) || {};
            return colInfo.col.key === COL_KEY_CHECKBOX ? {
                ...rawCellProps,
                onDoubleClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                },
            } : rawCellProps;
        },
    };
};